import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import amplitude from 'amplitude-js';
/*
Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Malekar
*/
@Component({
  selector: 'app-tac-support',
  templateUrl: './tac-support.component.html',
  styleUrls: ['./tac-support.component.css']
})
export class TacSupportComponent implements OnInit {
  [x: string]: any;
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");

  constructor(public googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.googleAnalyticsFunction('Support','Request Application Support','Request Application Support');
    amplitude.getInstance().logEvent("Request Application Support",{    "Main Menu": "Support" });
  }
  submit() {
    //window.open('https://mycase.cloudapps.cisco.com/case', '_blank');
    window.open('https://mycase.cloudapps.cisco.com/start?techId=54&subTechId=3002', '_blank');
  }
  googleAnalyticsFunction(actionName : string , eventName : string,eventLabel : string){

    this.googleAnalyticsService.eventEmitter(
      actionName ,      //eventName -> Partner Help
      'Menu',       //evtCategory ->Menu
      eventName,    //evtAction -> Sales
      eventLabel, //evtLabel -> Partner Help
      1           //evtValue
    );
  }
}
